import { render, staticRenderFns } from "./LoanPerformanceTeam.vue?vue&type=template&id=4f89f624&"
import script from "./LoanPerformanceTeam.vue?vue&type=script&lang=js&"
export * from "./LoanPerformanceTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports